import { useEffect, useState } from 'react'
import { InputBase, List, ListItem, ListItemButton, ListItemText, Paper, Modal, Box, IconButton, Icon } from '@mui/material'
import { Close } from '@mui/icons-material'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 400,
    minWidth: 310,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3
}

export const SelectionPopover = (props) => {
    const [items, setItems] = useState([])

    useEffect(() => {
        if (props.items.length > 0) {
            setItems(props.items)
        }
    }, [props.items])

    const inputSearch = (e) => {
        console.log(e.target.value)
        if (props.items.length > 0) {
            if (e.target.value.length > 2) {
                setItems(props.items.filter(i => {
                    if (i.name.toLowerCase().includes(e.target.value.toLowerCase())) return true
                    return false
                }))
            } else {
                setItems(props.items)
            }
        }
    }

    const handleKeyDown = (e) => {
        if (e.code === 'Enter') {
            e.preventDefault()
            console.log(e.target.value)
        }
    }

    return (
        <Modal
            id={props.id}
            open={props.open}
            onClose={props.handleClose}
        >
            <Box sx={{ ...style }}>
                <IconButton style={{ position: 'absolute', right: 5, top: 5 }} onClick={props.handleClose}>
                    <Close />
                </IconButton>
                <div style={{ width: '100%', padding: '30px 5px 5px 5px' }}>
                    <p style={{ fontSize: 10 }}>(*) Seleccione una máquina de la lista</p>
                    <Paper
                        component="form"
                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%' }}
                    >
                        {/* <input
                                onKeyDown={handleKeyDown}
                                placeholder="Buscador de máquinas"
                                onChange={inputSearch}
                            /> */}
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="Barra para filtrar"
                            inputProps={{
                                onKeyDown: handleKeyDown
                            }}
                            onChange={inputSearch}

                        />
                    </Paper>
                </div>
                <div style={{ maxHeight: 500, overflowY: 'auto' }}>
                    <List>
                        {
                            items.sort((a, b) => {
                                if (a.name > b.name) {
                                    return 1
                                }
                                if (a.name < b.name) {
                                    return -1
                                }
                                return 0
                            }).map((item, index) => {
                                return (
                                    <ListItem disablePadding key={index}>
                                        <ListItemButton
                                            disabled={item.disabled}
                                            onClick={(e) => { props.selectItem(item) }}
                                            style={item.disabled ? { color: 'lightgray' } : {}}
                                        >
                                            <ListItemText primary={item.name.toUpperCase()} />
                                        </ListItemButton>
                                    </ListItem>
                                )
                            })
                        }
                    </List>
                </div>
            </Box>
        </Modal>
    )
}
